const DonutYears = ({ years = 10, size = 25, strokeWidth = 4 }) => {
  const center = size / 2;
  const radius = (size - strokeWidth) / 2;
  const circumference = 2 * Math.PI * radius;
  const text = years >= 10 ? "10+" : years.toString();
  const dashArray = years >= 10 ? {on: 1, off: 0} : {on: years * 0.1, off: 1 - (years * 0.1)};
  
  return (
    <svg width={size+"px"} height={size+"px"} viewBox={`0 0 ${size} ${size}`} alt={years + " years of experience"}>
      <title>{text + " Years of experience"}</title>

      <circle
        cx={center}
        cy={center}
        r={radius}
        stroke="#cf9ca5"
        strokeWidth={strokeWidth}
        fill="none"
      />

      <circle
        cx={center}
        cy={center}
        r={radius}
        stroke="currentColor"
        strokeWidth={strokeWidth}
        fill="none"
        strokeDasharray={`${circumference * dashArray.on} ${circumference * dashArray.off}`}
        strokeLinecap="round"
        transform={`rotate(-80 ${center} ${center})`}
      />
      <text
        x="50%"
        y="50%"
        textAnchor="middle"
        dominantBaseline="central" // or "middle" depending on font
        fontSize={size * 0.4}
        fontWeight="bold"
        fontFamily="sans-serif"
        fill="currentColor"
      >
        {text}
      </text>
    </svg>
  );
};

export default DonutYears;